// Admin API client — /admin/trial-eligibility/* (mirrors the API's trial-eligibility aggregate).

import type { TrialEligibilityOverride, TrialEligibilityRecord } from '@a7y/types';
import { client } from './transport';

export const trialEligibilityApi = {
  // Trial Eligibility (A7Y-483)
  getTrialEligibilityOverrides: (params?: { limit?: number; offset?: number; search?: string }) => {
    const searchParams = new URLSearchParams();
    if (params?.limit) searchParams.set('limit', String(params.limit));
    if (params?.offset) searchParams.set('offset', String(params.offset));
    if (params?.search) searchParams.set('search', params.search);
    return client.get<{ data: TrialEligibilityOverride[]; total: number }>(
      `/trial-eligibility/overrides?${searchParams}`
    );
  },
  grantTrialEligibilityOverride: (data: { emailNormalized: string; reason: string }) =>
    client.post<{ success: true; override: TrialEligibilityOverride }>(
      '/trial-eligibility/overrides',
      data
    ),
  revokeTrialEligibilityOverride: (emailNormalized: string) =>
    client.delete<{ success: true; emailNormalized: string }>(
      `/trial-eligibility/overrides/${encodeURIComponent(emailNormalized)}`
    ),
  lookupTrialEligibilityRecord: (emailNormalized: string) =>
    client.get<{
      emailNormalized: string;
      record: TrialEligibilityRecord | null;
      override: TrialEligibilityOverride | null;
    }>(`/trial-eligibility/records/${encodeURIComponent(emailNormalized)}`),
};
